import React, { FC } from 'react'
import styled from 'styled-components'

import { SelectableTokenBaseCard } from '../../../../lib/cybersource/cards'
import CreditCard from './CreditCard'

interface CreditCardsProps {
  className?: string
  creditCards: ReadonlyArray<SelectableTokenBaseCard>
}
const CreditCards: FC<CreditCardsProps> = ({ className, creditCards }) => (
  <div className={className}>
    {creditCards.map((creditCard) => (
      <CreditCard creditCard={creditCard} key={creditCard.hash} />
    ))}
  </div>
)

const StyledCreditCards = styled(CreditCards)({
  display: 'grid',
  gap: '22px 25px',
  gridTemplateColumns: '1fr',
  '@media(min-width: 600px)': {
    gridTemplateColumns: '1fr 1fr',
  },
  '@media(min-width: 1200px)': {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
})

export default StyledCreditCards
